import axios from 'axios'
import router from '../router'
import Swal from 'sweetalert2'

import store from '../store';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.interceptors.request.use(request => {
    request['baseURL'] = window.location.protocol + "//" + window.location.hostname + (':3000');
    
    // request['baseURL'] = 'http://bphtb.tarakankota.go.id' + (':4000');
    request['baseURL'] = 'https://bphtb.tarakankota.go.id/services';
    // console.log(store.state.auth.token);
    if (store.state.auth.token) {
        request.headers.common['Authorization'] = 'Bearer ' + store.state.auth.token
    }
    return request
})

axios.interceptors.response.use(
    response => response,
    error => {
        const {
            status,
            data
        } = error.response


        if (status === 401) {
            Swal.fire({
                title: '', 
                text: 'Sesi Login Anda telah berakhir, harap login kembali.',
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Go back!'
            }).then(async() => {
                store.dispatch("auth/logout");
                router.push({
                    name: 'landing'
                })
            })
        }

        if (status === 403) {
            Swal.fire({
                title: 'warning',
                text: 'Anda tidak memiliki hak untuk mengakses halaman ini!',
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Go back!'
            }).then(async() => {
                router.push({
                    name: 'landing'
                })
            })
        }


        if (status === 409) {
            Swal.fire({
                icon: 'warning',
                title: '',
                text: typeof data === 'string' ? data : data.message
            })
        }

        if (status === 400) {
            Swal.fire({
                icon: 'error',
                title: '',
                text: typeof data === 'string' ? data : data.message
            })
        }

        if (status === 406) {
            Swal.fire({
                icon: 'error',
                title: '',
                html: 'Username / Password yang Anda masukan salah. <br> Atau/dan Akun Anda belum teraktivasi'
            })
        }

        if (status === 422) {
            var errorMsg = '';
            Object.keys(data).forEach(function(name) {
                errorMsg += data[name].toString() + '<br>'
            });
            Swal.fire({
                icon: 'warning',
                html: errorMsg,
            });
            return Promise.resolve(errorMsg)
        }

        if (status >= 500) {
            if (data instanceof Blob) {
                var myReader = new FileReader();
                //handler executed once reading(blob content referenced to a variable) from blob is finished. 
                myReader.addEventListener("loadend", function(e) {
                    let dataMsg = JSON.parse(e.srcElement.result); //prints a string

                    Swal.fire({
                        icon: 'error',
                        title: '',
                        text: dataMsg.message
                    })
                });
                //start the reading process.
                myReader.readAsText(data);
            } else {
                Swal.fire({
                    icon: 'error',
                    title: '',
                    text: data.message
                })
            }
        }

        return Promise.reject(error)
    }
)